import React from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay, EffectFade} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import styles from './AuthCarousel.module.css';
import slide1 from '../../../../assets/images/AuthCarousel/slide1.png';
import slide2 from '../../../../assets/images/AuthCarousel/slide2.png';
import slide3 from '../../../../assets/images/AuthCarousel/slide3.png';
import slide4 from '../../../../assets/images/AuthCarousel/slide4.png';
import slide5 from '../../../../assets/images/AuthCarousel/slide5.png';
import slide6 from '../../../../assets/images/AuthCarousel/slide6.png';
import FormattedText from '../../../../uiToolkit/FormattedText/FormattedText';
import {AuthRoot2Text} from '../AuthRoot2Text';

const slides = [
  {
    id: 1,
    img: slide1,
    text: AuthRoot2Text.carouselSlide1,
  },
  {
    id: 2,
    img: slide2,
    text: AuthRoot2Text.carouselSlide2,
  },
  {
    id: 3,
    img: slide3,
    text: AuthRoot2Text.carouselSlide3,
  },
  {
    id: 4,
    img: slide4,
    text: AuthRoot2Text.carouselSlide4,
  },
  {
    id: 5,
    img: slide5,
    text: AuthRoot2Text.carouselSlide5,
  },
  {
    id: 6,
    img: slide6,
    text: AuthRoot2Text.carouselSlide6,
  },
];

const AuthCarousel = () => {
  return (
    <Swiper
      modules={[Autoplay, EffectFade]}
      autoplay={{delay: 5000, disableOnInteraction: false}}
      effect="fade"
      fadeEffect={{crossFade: true}}
      loop
      className={styles.carousel}>
      {slides.map(slide => (
        <SwiperSlide key={slide.id}>
          <div className={styles.slide}>
            <img
              className={styles.image}
              src={slide.img}
              alt={`Slide ${slide.id}`}
            />
            <div className={styles.text}>
              <FormattedText text={slide.text} />
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default AuthCarousel;
